import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { yorkPaConfig } from "./data";

export default function YorkPaPage() {
  return <CityPageTemplate config={yorkPaConfig} />;
}